import { render, staticRenderFns } from "./OrangeStoneJpglistList.vue?vue&type=template&id=0c200c4e&scoped=true&"
import script from "./OrangeStoneJpglistList.vue?vue&type=script&lang=js&"
export * from "./OrangeStoneJpglistList.vue?vue&type=script&lang=js&"
import style0 from "./OrangeStoneJpglistList.vue?vue&type=style&index=0&id=0c200c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c200c4e",
  null
  
)

export default component.exports